<template>
  <div />
</template>

<script>
export default {
  layout: 'home',
  mounted() {
    this.$cookies.set('inviteCode', this.$route.params.invite, { path: '/', maxAge: 60 * 60 * 24 * 30 }) // 30 days
    window.location.replace('/cateiras')
  },
}
</script>
